// Helper para añadir un <input type="hidden"> a un form en runtime
// antes de hacerle submit programático. Lo usa onCustomSubmit en
// pantallas (email-otp, email-advise-otp, login-oauth-grant) donde el
// submitter button no envía su propio par name=value (porque es
// type="button"). Port 1:1 del addHiddenField de keycloak.coffee.

export function addHiddenField(
  formId: string,
  name: string,
  value: string,
): HTMLFormElement | null {
  const f = document.getElementById(formId) as HTMLFormElement | null;
  if (!f) return null;
  const input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", name);
  input.setAttribute("value", value);
  f.appendChild(input);
  return f;
}
